<script setup>
import {onMounted, ref, defineExpose} from "vue";
import CustomMask from "@/components/NewPC/CustomMask.vue";

const CustomMaskRef = ref(null);

const open = () => {
  CustomMaskRef.value?.open()
}

defineExpose({
  open
})
</script>

<template>
<custom-mask ref="CustomMaskRef">
  <div class="content" @click.stop>
    <img src="@/assets/newPc/tip_close_btn.png" class="close_icon" @click="open" alt="">
    <div class="title">《街球艺术玩家隐私政策》</div>
    <div class="body">
      <div>更新日期：2024年12月10日</div>
      <div>生效日期：2024年12月10日</div>
      <div>欢迎您选择由上海瑞酷数码科技有限公司（注册地址：【上海市闵行区东川路555号乙楼2108(集)B103室】，以下简称“我们”）提供的本产品。我们重视用户的隐私。您在使用我们的产品时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的我们平台游戏服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息</div>
      <div>请您仔细阅读此次隐私声明的更新内容：</div>
      <div>•“我们如何收集和使用您的个人信息”章节中，根据个人信息处理的合法基础进行了统一刷新。同时，增加了“个人信息收集清单”，可快速了解使用个人信息的基本情况。</div>
      <div><a href="https://www.racoondigi.cn/pages/personal_info_list.html" target="_blank">APP收集个人信息明示清单</a></div>
      <div>•“对未成年人的保护章节”，增加处理儿童个人信息的保护规则</div>
      <div>重要提醒：</div>
      <div>•为了便于您购买、下载、安装和管理您的应用，我们会收集您的个人信息。</div>
      <div>•我们联合合作伙伴为您提供丰富的应用和数字商品，您的帐号的昵称、评论、订单信息会被分享给相应的合作伙伴，以便为您提供更加优质的服务。</div>
      <div>•在您开启“游戏服务”后，为了向您提供排行榜、成就服务，我们会收集您在体验游戏应用时的相关数据。</div>
      <div>•在您参加活动获得实物奖品或者领取礼包、优惠券奖品时，为了向您派发实物奖品，我们需要与活动合作方和第三方物流公司共享您的联系方式信息。</div>
      <div>•为了对风险进行控制和识别，以保障您参与活动的合法权益，我们将会使用您的帐号和设备信息，下载以及其他页面操作信息。</div>
      <div>•本应用退出后，需要在后台连接网络完成部分服务，如更新应用、预约应用下载安装、接收消息。</div>
      <div>1 我们如何收集和使用您的个人信息</div>
      <div>在您使用或者后台运行APP时，我们可能会收集您的个人信息，您可以通过访问收集个人信息清单快速了解全功能服务下个人信息的使用情况，各功能收集个人信息的详细情况可查看下方说明。</div>
      <div>1.1 我们将通过游戏基础支持能力，为您提供下述业务功能，在您使用相关业务功能的过程中，我们会处理下列提供功能所必需的信息，以便履行我们的合同义务，确保您能正常使用本应用的相关功能。</div>
      <div>1.2 帮助您完成注册及登录</div>
      <div>为便于我们为您提供持续稳定的服务并保障您使用游戏服务的安全性， 我们需要您提供基本注册或登录信息，包括手机号码、电子邮箱地址，并创建您的账号、用户名和密码。在部分单项服务中，如果您仅需使用浏览、搜索基本功能，您不需要注册成为游戏用户及提供上述信息。</div>
      <div>依照相关法律法规规定及监管要求，我们会在获得您同意或您主动提供的情况下收集您的 姓名、有效身份证件信息（例如身份证）以完成实名身份认证。为实现实名认证的目的， 您同意并授权我们可能向有关实名认证机构（国家网络游戏主管部门、公安部门或者其委托/合作的其他机构）提供、查询、核对您的前述身份信息。请注意，您的身份信息（包括姓名、身份证号、照片信息）属于敏感个人信息，请您谨慎提供，如果拒绝提供将可能导致您无法登录游戏或在使用游戏的过程中受到相应限制。</div>
      <div>您也可以在注册、登录或后续使用过程中， 填写或补充您的其他额外信息（例如您的昵称、头像、性别、出生日期、兴趣爱好），这将有助于我们给您提供更优的服务体验，但如果您不提供这些信息，并不会影响您使用游戏服务的基本功能。</div>
      <div>提供游戏基本功能，维护网络及运营安全</div>
      <div>在您使用我们服务过程中，为向您提供基本的游戏服务，并识别账号异常状态、了解产品适配性、保障中手游游戏服务的网络及运营安全，以维护前述基本功能的正常运行，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入安全风险，更准确地识别违反法律法规的情况，我们可能会收集、存储关于您使用的服务以及使用方式的 日志信息、设备信息、账号信息、交易信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，并将这些信息进行关联来综合判断您的交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施：</div>
      <div>（1） 日志信息：当您使用我们的服务时，我们可能会自动收集您的游戏日志信息，例如:您的登录日志、物品日志、操作信息、游戏对局信息、游戏好友信息及互动记录、登录、游戏ID、搜索查询内容、IP地址、浏览器的类型、电信运营商、网络环境、使用的语言、访问日期和时间及您访问的网页浏览记录、Push打开记录、刷新记录、停留时长、发布记录、关注、订阅、收藏及分享。</div>
      <div>（2） 设备信息：为保障您正常使用我们游戏服务，维护游戏基础功能的正常运行，提升游戏体验和保障账号安全，我们可能会接收并记录您所使用的设备信息。例如：设备名称、设备机型、操作系统及版本、客户端版本、设备分辨率、包名、设备设置、进程及已安装包名列表、设备标识符（MAC地址/IMEI/Android ID/IDFA/OpenUDID/GUID/SIM 卡IMSI/SIM卡序列号/设备序列号/MEID/OAID/DEVICEID 信息）、WIFI的BSSID及SSID、软硬件特征信息、IP地址、特定类型传感器（游戏运动传感器、加速度传感器、监视传感器、陀螺仪传感器、线性加速度传感器）。为了收集上述基本的个人设备信息，我们将会在必要场景申请访问您的设备信息的权限。</div>
      <div>请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。这些信息在结合使用期间，将作为您的个人信息按照本政策处理与保护。</div>
      <div>（3） 账号信息：为保障您的账号安全，营造公平、健康及安全的游戏环境，我们会收集您的游戏识别信息、硬件及操作系统信息、应用列表、进程及游戏崩溃记录账号信息，以用于打击破坏游戏公平环境或干扰、破坏游戏服务正常进行的行为（如用于检测盗版、扫描外挂、防止作弊）。</div>
      <div>（4） 交易信息：当您使用游戏服务的消费功能时，我们会收集您的充值记录、消费记录交易信息，以便提供服务并允许您查询您的交易记录，同时尽最大程度保护您的虚拟物品安全。充值记录、消费记录属于敏感个人信息，收集上述信息为实现游戏产品的消费功能所必须，否则将无法完成交易。</div>
      <div>（5）在您同意访问媒体权限后，您允许我们获取您的图片、音频和视频内容，以便您能在游戏中自由更换头像，获取更好的游戏体验。</div>
      <div>向您提供互动与发布服务</div>
      <div>您在使用游戏服务时、上传和/或发布信息以及进行相关互动行为（例如发布 跟贴、回复跟贴、顶贴、喜欢文章、分享、收藏、留言、打赏）时，我们将收集您上传、发布或形成的信息，并使用您的昵称、头像、游戏ID、虚拟角色形象和发布内容以作展示。</div>
      <div>请注意，您公开发布的信息中可能包含您的个人信息或敏感个人信息，请您在发布前慎重考虑。如您发布的信息涉及到他人的个人信息的，您应当在发布前征得他人同意。当您发现他人不正当地收集或使用您的信息时，可通过本政策“如何联系我们”章节所列的反馈渠道联系我们。</div>
      <div>帮助您完成下单、支付并向您交付商品或服务</div>
      <div>（1）当您在游戏服务中订购具体商品及/或服务时，为向您展示账号的交易信息并保障交易安全，我们会通过系统为您生成购买该商品及/或服务的订单，收集您的具体订单号、订单创建时间、交易金额信息，用于向您展示及便于您对订单进行交易管理。在下单过程中，您可能需要提供 收货人姓名、收货地址、联系电话信息。如果您拒绝提供此类信息，我们将无法完成相关交付服务，但不影响其他功能与服务的正常使用。</div>
      <div>（2）为完成订单支付、交付商品或服务、确认交易状态及为您提供售后与争议解决服务， 我们会通过您基于交易所选择的交易对象、支付机构、物流公司，收集与交易进度相关的您的账号、订单、交易、支付信息，或在取得您单独同意的情况下将您的交易信息共享给上述服务提供者。充值记录、消费记录属于敏感个人信息，收集上述信息为实现游戏产品的消费功能所必须，否则将无法完成交易。</div>
      <div>为您提供客服或其他用户响应功能</div>
      <div>当您联系我们的客服或使用其他用户响应功能时（例如提出售中售后申请、个人信息保护投诉或建议、未成年人游戏相关投诉或其他客户投诉和需求）， 我们可能需要您提供必要的个人信息以匹配并核验您的用户身份，以便保障您的账号与系统安全。为处理您的诉求，人工客服需要在您授权范围内查询或核验您的相关信息并仅在必要范围内使用，如您拒绝提供或提供错误的，我们可能无法向您提供相应支持。在确认您用户身份后，我们还会保存您的联系方式（您与我们联系时使用的或您向我们主动提供的其他联系方式）、您与我们的通信/通话记录和内容、与您需求相关联的其他必要信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</div>
      <div>我们通过间接方式收集到的您的个人信息</div>
      <div>基于您选择使用的游戏服务，我们可能从关联方、第三方合作伙伴获取您授权共享的相关信息。例如，当您使用第三方平台的账号登录游戏服务时，我们将根据您的授权获取该第三方账号下的相关信息（包括：用户名、昵称、头像，具体以您的授权内容为准）， 并在您同意本政策后将您的第三方账号与您的游戏服务账号绑定，使您可以通过第三方账号直接登录并使用游戏。我们将在符合相关法律法规规定，并依据与关联方或第三方合作伙伴的约定、确信其提供的信息来源合法的前提下，收集并使用您的这些信息。</div>
      <div>您理解并同意，使用游戏的过程中，我们将在必要时申请访问您的系统权限，以实现这些权限所涉及信息的收集和使用。我们在开启权限前，将告知您开启权限的目的并征求您的同意，如您不同意，我们将不会开启相关权限，也无法为您提供该权限所对应的服务，但不影响您正常使用游戏的其他功能，您也可以随时取消相关权限授权，但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</div>
      <div>（1）在您同意访问存储权限后，您允许我们访问您的存储空间，以便使您可以下载并保存内容，或者通过缓存来实现相应服务功能；</div>
      <div>（2）在您同意访问设备信息权限后，您允许我们获取您的设备信息以作为您设备的唯一性标识，了解产品适配性、识别异常状态以及保障游戏服务的网络及运营安全；</div>
      <div>（3）在您同意访问位置权限后，我们可以获取您的位置信息，以便让您与附近的朋友进行信息交互、指引您位置移动、或向您推送内容；位置信息为敏感个人信息位置信息为敏感个人信息，如您不同意，只会使得您无法与附近玩家互动、精准位置移动或接受对应的内容，但不会影响您使用游戏与位置权限无关的其他功能，您也可以随时取消您的位置信息授权</div>
      <div>（4）在您同意访问应用列表权限后，我们可以获取您的应用列表信息，以便在应用列表异常变动时及时发现恶意软件并提醒您注意账户安全，从而维护手机系统环境的安全。</div>
      <div>（5）在您同意访问获取运行中的应用权限后，您允许我们获取您运行中的应用，以便我们能够合理使用系统资源，帮助您提高游戏加载或更新的稳定性和安全性。</div>
      <div>我们可能收集的信息</div>
      <div>我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</div>
      <div>1.您提供的信息：</div>
      <div>（1）您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件或银行卡号；</div>
      <div>（2）您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。</div>
      <div>2.其他方分享的您的信息：</div>
      <div>（1）其他方使用我们的服务时所提供有关您的共享信息。</div>
      <div>3.我们获取的您的信息您使用服务时我们可能收集如下信息：1.日志信息，指您使用我们的服务时，系统可能通过cookies、web beacon或其他方式自动采集的技术信息，包括：</div>
      <div>（1）设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备标识符；</div>
      <div>（2）在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；</div>
      <div>（3）有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该移动应用和软件的信息；</div>
      <div>（4）您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；</div>
      <div>（5）您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点。</div>
      <div>4位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：</div>
      <div>（1）您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi方式收集的您的地理位置信息；</div>
      <div>（2）您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的帐户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；</div>
      <div>（3）您可以通过关闭定位功能，停止对您的地理位置信息的收集。</div>
      <div>我们可能如何使用信息</div>
      <div>我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</div>
      <div>1.向您提供服务；</div>
      <div>2.在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存盘和备份用途，确保我们向您提供的产品和服务的安全性；</div>
      <div>3.说明我们设计新服务，改善我们现有服务；</div>
      <div>4.软件认证或管理软件升级；</div>
      <div>您如何访问和控制自己的个人信息</div>
      <div>我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。</div>
      <div>我们可能分享的信息</div>
      <div>除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：</div>
      <div>1.我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供货商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供货商）分享（他们可能并非位于您所在的法域），用作下列用途：</div>
      <div>（1）向您提供我们的服务；</div>
      <div>（2）实现“我们可能如何使用信息”部分所述目的；</div>
      <div>（3）履行我们在《服务协议》或本《隐私政策》中的义务和行使我们的权利；</div>
      <div>（4）理解、维护和改善我们的服务。如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。</div>
      <div>2.随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：</div>
      <div>（1）遵守适用的法律法规；</div>
      <div>（2）遵守法院命令或其他法律程序的规定；</div>
      <div>（3）遵守相关政府机关的要求；</div>
      <div>（4）为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</div>
      <div>信息安全</div>
      <div>我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</div>
      <div>您分享的信息</div>
      <div>我们的多项服务，可让您不仅与自己的社交网络，也与使用该服务的所有使用者公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的响应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他使用者也有可能分享与您有关的信息（包括位置数据和日志信息）。特别是，我们的社交媒体服务，是专为使您与世界各地的用户共享信息而设计，您可以使共享信息实时、广泛地传递。 只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该第三方在公共领域保存。因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该特别服务条款提供的方式操作。</div>
      <div>您分享的敏感个人信息</div>
      <div>某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息。相比其他个人信息，敏感个人信息受到更加严格的保护。请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。您同意按本《隐私政策》所述的目的和方式来处理您的敏感个人信息。</div>
      <div>隐私政策的适用例外</div>
      <div>我们的服务可能包括或连结至第三方提供的社交媒体或其他服务（包括网站）。例如：您利用“分享”键将某些内容分享到我们的服务，或您利用第三方联机服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的计算机装置cookies，从而正常运行上述功能；我们通过我们服务的其他方式向您提供连结，使您可以接入第三方的服务或网站。该第三方社交媒体或其他服务可能由相关的第三方或我们运营。您使用该第三方的社交媒体服务或其他服务（包括您向该第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非《通用服务条款》或本《隐私政策》）约束，您需要仔细阅读其条款。本《隐私政策》仅适用于我们所收集的信息，并不适用 于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。</div>
      <div>未成年人保护方面</div>
      <div>1、若您是未满18周岁的未成年人，您应在您的监护人监护、指导下并获得监护人同意的情况下，认真阅读并同意本协议后，方可使用本软件及相关服务。若您未取得监护人的同意，监护人可以通过联系我们官方公布的客服联系方式通知我们处理相关账号我们有权对相关账号的功能、使用进行限制，包括但不限于浏览、发布信息、互动交流功能。</div>
      <div>2、我们非常重视对未成年人个人信息的保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，并应在取得监护人的同意以及在监护人指导下正确使用本软件及相关服务。</div>
      <div>3、未成年人用户及其监护人理解并确认，如您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担因此而可能导致的全部法律责任。</div>
      <div>4、我们专门为未成年人提供青少年模式，监护人应为未成年人选择使用青少年模式。</div>
      <div>5、未成年人用户特别提示</div>
      <div>（1）未成年人使用本软件及相关服务应该在其监护人的监督指导下，在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，养成良好上网习惯；</div>
      <div>（2）青少年用户必须遵守《全国青少年网络文明公约》；</div>
      <div>（3）要善于网上学习，不浏览不良信息；</div>
      <div>（4）要诚实友好交流，不侮辱欺诈他人；</div>
      <div>（5）要增强自护意识，不随意约会网友；</div>
      <div>（6）要维护网络安全，不破坏网络秩序；</div>
      <div>（7）要有益身心健康，不沉溺虚拟时空。</div>
      <div>6、为更好地保护未成年人隐私权益，我们特别提醒您慎重发布包含未成年人素材的内容，一经发布，即视为您已获得权利人同意在本软件及相关服务展示未成年人的肖像、声音信息，且允许我们依据本协议使用、处理该与未成年人相关的内容。</div>
      <div>7、监护人特别提示</div>
      <div>（1）如您的被监护人使用本软件及相关服务的，您作为监护人应指导并监督被监护人的注册和使用行为，如您的被监护人申请注册怪猫账号，我们将有权认为其已取得您的同意；</div>
      <div>（2）您的被监护人在使用本软件及相关服务时可能使用购买产品或服务功能。您作为监护人，请保管好您的支付设备、支付账户及支付密码，以避免被监护人在未取得您同意的情况下通过您的怪猫账号使用购买消费功能。</div>
      <div>隐私政策的适用范围除某些特定服务外，我们所有的服务均适用本《隐私政策》。这些特定服务将适用特定的隐私政策。针对某些特定服务的特定隐私政策，将更具体地说明我们在该服务中如何使用您的信息。该特定服务的隐私政策构成本《隐私政策》的一部分。如相关特定服务的隐私政策与本《隐私政策》有不一致之处，适用该特定服务的隐 私政策。除本《隐私政策》另有规定外，本《隐私条款》所用词语将与《服务协议》所定义的词语具有相同的涵义。请您注意，本《隐私政策》不适用于以下情况：</div>
      <div>1.通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息；</div>
      <div>生效前通 过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。</div>
      <div>第三方共享信息</div>
      <div>为了向您提供部分功能/服务，例如评论服务、网络加速服务、奖品快递服务、游戏服务，我们需要将您的个人信息提供给第三方。为了保障您的数据安全和隐私，我们与合作伙伴签订了数据安全保护协议，明确了合作伙伴对您的数据的保护责任、义务和要求。</div>
      <div><a href="https://www.racoondigi.cn/pages/share_info_list.html" target="_blank">详细查看：第三方共享信息清单</a></div>
      <div>第三方SDK列表</div>
      <div>部分服务需要由我们与合作伙伴共同为您提供，例如社交分享，为此我们集成了合作伙伴的软件工具开发包（简称“SDK”）或其他类似的应用程序。</div>
      <div><a href="https://www.racoondigi.cn/pages/third_party_sdk.html" target="_blank">第三方SDK列表</a></div>
      <div>管理您的个人信息</div>
      <div>您可以通过联系客服，更正或删除您的个人信息，或撤回对个人信息使用权的同意。客服联系方式：supervision@racoondigi.com  通过“控制对您帐号的访问”来取消授权，之后该三方游戏应用将无权访问您的“游戏服务”数据。</div>
      <div>信息更正</div>
      <div>当您需要更新您的个人信息，或发现我们处理您的个人信息有误时，您有权作出更正或更新。您可以联系客服，提出并修改个人信息。</div>
      <div>注销服务</div>
      <div>您可以通过联系客服，要求停止个人信息的收集和使用，并切断和游戏帐号的关联，注销此服务不会影响到您对其他产品或服务的使用。</div>
      <div>如您对您的数据主体权利有进一步要求或存在任何疑问、意见或建议，可通过本声明中“客服联系方式：supervision@racoondigi.com  ，与我们取得联系并行使您的相关权利。</div>
      <div>信息存储地点及期限</div>
      <div>上述数据将会传输并保存至【中华人民共和国境内】的服务器。</div>
      <div>我们会在以下情况处理您的信息：</div>
      <div>我们仅在实现本声明所述目的所必需的时间内保留您的个人信息，并在超出下述保留时间后删除或匿名化处理您的个人信息，除非法律法规另有要求。</div>
      <div>您的设备标识符、帐号信息、操作系统的设置信息、设备的硬件信息、网络信息、应用的基本信息、已安装应用软件列表、应用卸载列表、有关您使用本应用的信息、礼包兑换码、优惠券、有关您使用评论的信息、问题与建议信息、消费特权级别、预约记录、联系方式、活动参与记录和信息存储不超过5年或在您注销帐号后自动删除。</div>
      <div>“游戏服务”相关数据（除存档数据外）将被保存2年。</div>
      <div>您的订单信息将在订单产生之后保存7年。</div>
      <div>您的活动信息在活动结束一年后或您注销帐号时删除。</div>
      <div>您的活动分享记录信息将被保存6个月或在您注销帐号后自动删除。</div>
      <div>我们收到的来自合作伙伴共享的数据，包括您在其应用内的操作信息，会被保存2年后自动删除或者在您注销帐号后立即删除。</div>
      <div>您的运营商信息将会在使用后立即删除，不会被存储在服务器。</div>
      <div>此外，当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</div>
      <div>10 如何联系我们</div>
      <div>客服联系方式：<a href="mailto:supervision@racoondigi.com">supervision@racoondigi.com</a></div>
      <div>如果您对我们的回复不满意，特别是当我们的个人信息处理行为损害了您的合法权益时，您还可以通过向有管辖权的人民法院提起诉讼、向行业自律协会或政府相关管理机构投诉外部途径进行解决。您也可以向我们了解可能适用的相关投诉途径的信息。</div>
    </div>
  </div>
</custom-mask>
</template>

<style scoped lang="scss">
.content {
  width: 43.2421875vw;
  height: 22.7734375vw;
  background: transparent url("@/assets/newPc/privacy_agreement_bg.png") no-repeat center center;
  background-size: contain;
  position: relative;

  .close_icon {
    width: 1.5625vw;
    height: 1.5625vw;
    position: absolute;
    top: 0.859375vw;
    right: 0.9375vw;
  }

  .title {
    color: #6B6660;
    font-size: 1.015625vw;
    text-align: center;
    line-height: 1;
    padding-top: 1.875vw;
    margin-bottom: 1.09375vw;
  }

  .body {
    height: 16.484375vw;
    padding: 0 2.9296875vw;
    box-sizing: border-box;
    overflow-y: auto;
    color: #6B6660;
    font-size: 0.859375vw;
  }
}
</style>